<template>

  <v-dialog value="true" persistent max-width="560px">
      <v-card>
        <v-card-title class="justify-center secondary">Identification de la prise</v-card-title>
        <v-card-text>
          <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
      >
    <p class="question">Avez-vous une prise dans votre logement ?</p>

    <v-radio-group v-model="choixPriseLogement" :rules="[v => !!v || 'Choix requis']" required>
      <v-radio class="radio-size" label="Oui" value="OUI"></v-radio>
      <v-radio class="radio-size" label="Non" value="NON"></v-radio>
    </v-radio-group>

    <div v-if="choixPriseLogement == 'OUI'">
      <p class="question mt-4">Connaissez-vous la référence de la prise ?</p>

      <v-radio-group v-model="choixReferencePrise" :rules="[v => !!v || 'Choix requis']" required row>
        <v-radio class="radio-size" label="Oui" value="OUI"></v-radio>
        <v-radio class="radio-size" label="Non" value="SUSPICION"></v-radio>
      </v-radio-group>

      <v-text-field
        v-if="choixReferencePrise == 'OUI'"
        v-model="refPriseSaisie"
        label="Référence de prise"
        :rules="[v => !!v || 'Référence de prise requise']"
        required
      ></v-text-field>
    </div>

    <v-card-actions>
      <v-btn @click="$emit('closeDialogRefPrise')">Annuler</v-btn>
     <v-spacer></v-spacer>
     <v-btn @click="valideRefPrise" color="primary" :disabled="isValiderDisabled" :loading="loading"
      class="white--text"
     >Valider</v-btn>
   </v-card-actions>
     </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

export default {
 name:"RefPrise",
  data () {
    return {
      loading:false,
      valid: true,
      choixPriseLogement : null,
      choixReferencePrise : 'OUI',
      refPriseSaisie : null,

    lazy: false,
    }
  },
  computed: {
    isValiderDisabled() {
      if(this.loading) {
        return true;
      }

      if(!this.choixPriseLogement) {
        return true;
      }

      if(this.choixPriseLogement == 'OUI') {
        if(!this.choixReferencePrise) {
          return true;
        }
        if(this.choixReferencePrise == 'OUI' && !this.refPriseSaisie) {
          return true;
        }
      }

      return false;
    }
  },
  methods: {
    valideRefPrise: function(){
      var choixFinal = null;
      if(this.choixPriseLogement == 'NON') {
        choixFinal = 'NON';
      } else if(this.choixReferencePrise == 'OUI') {
        choixFinal = 'OUI';
      } else {
        choixFinal = 'SUSPICION';
      }

      this.loading = true;
      this.$emit("valideRefPrise", choixFinal, this.refPriseSaisie, () => { this.loading = false; });
    }
  }
}
</script>
<style scoped>
.radio-size{
    font-size:15px !important;
}
 .question{
   font-size:1.16rem !important;
}
 .v-card__title{
   color: white;
}
</style>
